export type AppSection = "login" | "observability" | "app";

export const sectionPath: Record<AppSection, string> = {
  login: "/login",
  observability: "/observability",
  app: "/app"
};

const appPathPrefixes = ["/app", "/tasks", "/usage"];

export function resolveSection(pathname: string): AppSection {
  const normalized = normalizePath(pathname);
  if (normalized === "/" || normalized === "/login" || normalized === "/auth") {
    return "login";
  }
  if (normalized === "/observability" || normalized === "/status") {
    return "observability";
  }
  if (appPathPrefixes.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`))) {
    return "app";
  }
  return "login";
}

export function canAccessSection(section: AppSection, isAuthenticated: boolean): boolean {
  return section !== "app" || isAuthenticated;
}

export function postAuthPath(section: AppSection): string {
  return section === "observability" ? sectionPath.observability : sectionPath.app;
}

function normalizePath(pathname: string): string {
  const withoutHash = pathname.split("#", 1)[0] ?? "/";
  const withoutQuery = withoutHash.split("?", 1)[0] ?? "/";
  const normalized = withoutQuery.startsWith("/") ? withoutQuery : `/${withoutQuery}`;
  return normalized.replace(/\/+$/, "") || "/";
}
